import { useNavigate, useParams } from 'react-router-dom';
import { Button, message } from 'antd';

import { usePostRequest } from 'hooks';

import { Links } from 'links';

import { ProductDetails } from 'codegen';

export const CopyProduct = () => {
  const { productId } = useParams();
  const navigate = useNavigate();

  const [copyProduct, { loading }] = usePostRequest<ProductDetails>({
    url: `products/details/${productId}`,
    options: {
      onSuccess: ({ data }) => {
        message.success('Product copied successfully!');
        navigate(`${Links.Products}/${data.id}`);
      },
    },
  });

  return (
    <Button
      size='small'
      type='primary'
      loading={loading}
      onClick={() => copyProduct()}
    >
      Copy this product
    </Button>
  );
};
